import { View, Text, Image } from "@react-pdf/renderer";
import styles from "../../css";

import AddaLogo from "../../images/adda-logo.png";
import Adda2022 from "../../images/2022-adda-header.png";

export const HeaderImages = () => {
  return (
    <View style={styles.header_container}>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Image style={styles.logo_img_left} src={AddaLogo} />
        <Image style={styles.logo_img_right} src={Adda2022} />
      </View>
    </View>
  );
};

const Header = () => {
  return (
    <View style={styles.section_top} fixed>
      <HeaderImages />
    </View>
  );
};

export default Header;
